import React from 'react';

function ExerciseHistoryModal( {data, setShowExerciseHistoryModal}) {

    const getFormattedDate = (key) => {
        const year = "20" + key.slice(0, 2);
        const month = key.slice(2, 4);
        const day = key.slice(4, 6);
        const date = new Date(`${year}-${month}-${day}`);
        const options = { day: "2-digit", month: "short" };
        return date.toLocaleDateString("en-US", options);
    };

    const rows = [];

    Object.entries(data).forEach(([key, { r, w, k }]) => {
        w.forEach((weight, i) => {
            const unit = k[i] ? "KG" : "LBS";
            const reps = r[i] || r[0];
            const date = getFormattedDate(key);
            rows.push({ date, weight, unit, reps });
        });
    });

    function closeModal(){
        setShowExerciseHistoryModal(false);
    }

    return (
        <div className="modal" style={{display: "flex"}}>
            <div className="modal-content-centered">
                <span onClick={closeModal} className="close">&times;</span>
                <div className="modal-section">
                    <div style={{margin: "auto", width: "250px", marginTop: "10px"}}>
                        <a style={{fontSize: "21px", fontWeight: "500"}}>{}</a>
                        {rows.map((row, index) => (
                            <div key={index} style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "8px 0",
                                fontWeight: "bold"
                            }}>
                                <div>
                                    <span style={{ color: "gray" }}>{row.date}</span>{" "}
                                    {row.weight}{" "}
                                    <span style={{ color: "var(--color-exerprise-system-blue)" }}>{row.unit}</span>{" "}
                                    {row.reps} <span style={{ color: "var(--color-exerprise-system-blue)" }}>REPS</span>
                                </div>
                                <div style={{ color: "gray" }}>{">"}</div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ExerciseHistoryModal;